export default __webpack_public_path__ + "static/media/needleproto_demo_image.2faac7b5.gif";